import { formatCurrency, formatNumber } from '@/utils'
// eslint-disable-next-line no-unused-vars
import { Chart as ChartJS } from 'chart.js/auto' // this is necessary to bootstrap the chart 
import { Bar } from 'react-chartjs-2'
import './CheckDetailsProduction.css'


const chartColors = [
    'rgb(75, 192, 192)', // green
    'rgb(54, 162, 235)', // blue
    'rgb(153, 102, 255)', // purple
    'rgb(255, 99, 132)', // pink
    'rgb(201, 203, 207)', // grey
    'rgb(255, 159, 64)', // gold
    'rgb(255, 205, 86)', // yellow
]

const chartOptions = {
    color: '#a4a4a4',
    responsive: true,
    scales: {
        y: {
            ticks: {
                color: '#a4a4a4',
                callback: value => formatCurrency(value),
            },
        },
        x: {
            ticks: {
                color: '#a4a4a4',
            },
        },
    },
    plugins: {
        tooltip: {
            callbacks: {
                label: tooltipItems => `Owner Net Revenue: ${formatCurrency(tooltipItems.parsed.y)}`,
            },
        },
    },
}

const CheckDetailsProduction = ({ checkProduction }) => {
    return (
        <div className="flex flex-col lg:flex-row gap-4 CheckDetailsProduction pb-5">
            <div className="flex-1 lg:w-[50%]">
                <Bar
                    updateMode="active"
                    className="min-h-[300px] max-h-[300px]"
                    data={{
                        labels: checkProduction?.map(cp => cp.productionType),
                        datasets: [{
                            label: 'Owner Net Revenue',
                            data: checkProduction?.map(cp => cp.ownerValueSum),
                            backgroundColor: chartColors,
                        }],
                    }}
                    options={chartOptions} /> 
            </div>
            
            {/* <div className="flex flex-1 gap-3 flex-wrap w-full">
                {[...checkProduction, ...checkProduction, ...checkProduction]?.map(cp => 
                    <div key={cp.productionType} className="flex flex-col text-center card-production">
                        <span className="badge badge-secondary mb-3">{cp.productionType}</span>
                        <div className="flex flex-col px-3 gap-3">
                            <div>
                                <label className="mb-1">Production Gross Volume</label>
                                <div className="production__value">{formatNumber(cp.propertyVolumeSum || 0)}</div>
                            </div>
                            <div>
                                <label className="mb-1">Owner Volume</label>
                                <div className="production__value">{formatNumber(cp.ownerVolumeSum || 0)}</div>
                            </div>
                            <div>
                                <label className="mb-1">Owner Net Revenue</label>
                                <div className="production__value">{formatCurrency(cp.ownerValueSum || 0)}</div>
                            </div>
                            <div>
                                <label className="mb-1">Average Price</label>
                                <div className="production__value">{formatCurrency(cp.weightedAvg || 0)}</div>
                            </div>
                        </div>
                    </div>,
                )}
            </div> */}
            <div className="flex-1">
                <table className="mt-4 table-auto table-sticky-headers">
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Production Gross Volume</th>
                            <th>Owner Volume</th>
                            <th>Owner Net Revenue</th>
                            <th>Average Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {checkProduction?.map((cp, idx) => (
                            <tr key={idx}>
                                <td>{cp.productionType}</td>
                                <td>{formatNumber(cp.propertyVolumeSum || 0)}</td>
                                <td>{formatNumber(cp.ownerVolumeSum || 0)}</td>
                                <td>{formatCurrency(cp.ownerValueSum || 0)}</td>
                                <td>{formatCurrency(cp.weightedAvg || 0)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default CheckDetailsProduction
